import { Box } from '@mui/material';

import type { OfferMemberProgress } from '@ocx/data-offers';

import { Bar } from './components/bar.component';
import { Punches } from './components/punches.component';
import { OfferProgressFormatVariant, OfferProgressVariant } from '../offer-card/offer-card.types';

export const OFFER_PROGRESS_TEST_ID = 'offer-progress';

export type OfferProgressOverTimeProps = {
  progress: OfferMemberProgress;
  variant: OfferProgressVariant;
  formatVariant: OfferProgressFormatVariant;
};

export const OfferProgressOverTime = ({
  progress: { required, achieved },
  variant,
  formatVariant,
}: OfferProgressOverTimeProps) => {
  const isPunchesVariant = variant === 'punches';

  return (
    <Box display="flex" alignSelf="stretch" data-testid={OFFER_PROGRESS_TEST_ID}>
      {isPunchesVariant ? (
        <Punches required={required} achieved={achieved} />
      ) : (
        <Bar achieved={achieved} required={required} variant={formatVariant} />
      )}
    </Box>
  );
};
